export class CompletionStat {
  nbSuccess: number;
  nbFailed: number;
  nbInProgress: number;
  nbUnread: number;

  constructor(
    nbSuccess: number,
    nbFailed: number,
    nbInProgress: number,
    nbUnread: number
  ) {
    this.nbSuccess = nbSuccess;
    this.nbFailed = nbFailed;
    this.nbInProgress = nbInProgress;
    this.nbUnread = nbUnread;
  }
}
